import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground shadow',
        secondary: 'border-transparent bg-secondary text-secondary-foreground',
        destructive: 'border-transparent bg-destructive text-destructive-foreground shadow',
        outline: 'text-foreground',
        pending: 'border-orange-300 dark:border-orange-700 bg-orange-100 dark:bg-orange-900 text-orange-700 dark:text-orange-300',
        approved: 'border-green-300 dark:border-green-700 bg-green-100 dark:bg-green-900 text-green-700 dark:text-green-300',
        rejected: 'border-red-300 dark:border-red-700 bg-red-100 dark:bg-red-900 text-red-700 dark:text-red-300',
        // HSM-specific variants
        active: 'border-blue-300 dark:border-blue-700 bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300',
        paused: 'border-yellow-300 dark:border-yellow-700 bg-yellow-100 dark:bg-yellow-900 text-yellow-700 dark:text-yellow-300',
        completed: 'border-purple-300 dark:border-purple-700 bg-purple-100 dark:bg-purple-900 text-purple-700 dark:text-purple-300',
        optedOut: 'border-gray-300 dark:border-gray-700 bg-gray-100 dark:bg-gray-900 text-gray-700 dark:text-gray-300',
        sent: 'border-cyan-300 dark:border-cyan-700 bg-cyan-100 dark:bg-cyan-900 text-cyan-700 dark:text-cyan-300',
        delivered: 'border-green-300 dark:border-green-700 bg-green-100 dark:bg-green-900 text-green-700 dark:text-green-300',
        read: 'border-emerald-300 dark:border-emerald-700 bg-emerald-100 dark:bg-emerald-900 text-emerald-700 dark:text-emerald-300',
        failed: 'border-red-300 dark:border-red-700 bg-red-100 dark:bg-red-900 text-red-700 dark:text-red-300'
      }
    },
    defaultVariants: {
      variant: 'default'
    }
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
